import React, { useEffect, useState } from "react";
import { Link, withRouter, useHistory, useLocation } from "react-router-dom";
import FAQBlock from "./faqblock";
import logo from "../../assets/images/Logo.png";

const FAQ = () => {
  
  return (
    <React.Fragment>
      <div className="navbar-header container mb-3">
        <div className="d-flex">
          <div className="navbar-brand-box">
            <Link to="/" className="logo logo-light">
              <span className="logo-lg">
                <img src={logo} alt="genni" className="nav-logo" />
              </span>
            </Link>
          </div>
          
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="d-flex mr-3">
            <Link to="/login">
              <span className="text-black">Login</span>
            </Link>
          </div>
          <div className="">
            <Link
              to="/hello"
              className="btn gradient-pink btn-pink text-white w-100 waves-effect waves-light p-3"
            >
              Sign Up
            </Link>

          </div>
        </div>
        
      </div>
      <div className="container">
        <FAQBlock />
      </div>
    </React.Fragment>
  );
};

export default FAQ;
